import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import constant from "../../constant";

export default class FavAction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      favorite: ""
    };
  }

  fav_upd_count = () => {
    let space_id = localStorage.getItem("favorites");
    space_id = space_id ? space_id.replace("[", "") : null;
    space_id = space_id ? space_id.replace("]", "") : null;

    let curr = JSON.parse(localStorage.getItem("O_Auth"));
    let _this = this;

    if (space_id) {
      axios
        .get(`${constant.phpHost}action/favorites.php`, {
          params: {
            todo: "get_fav_spaces",
            space_id: space_id,
            cur_val: curr ? curr.currency : 1
          }
        })
        .then(function(res) {
          _this.setState(
            {
              favorite: res.data && res.data.length > 0 ? res.data.length : ""
            },
            _this.updateFavCountHeader
          );
        });
    } else {
      _this.setState(
        {
          favorite: ""
        },
        _this.updateFavCountHeader
      );
    }
  };

  toggleFav = (space_id, status) => {
    let login_storage = JSON.parse(localStorage.getItem("O_Auth"));
    let login_id = login_storage ? login_storage.id : null;

    if (login_id) {
      axios
        .get(`${constant.phpHost}action/favorites.php`, {
          params: {
            todo: "toggle_fav",
            favourites: space_id,
            user_id: login_id,
            status_f: status
          }
        })
        .then(function(res) {
          // console.log(res);
        });
    }
  };

  favorites = space_id => {
    let fav_storage = JSON.parse(localStorage.getItem("favorites"));
    if (fav_storage) {
      if (fav_storage.length === 0) {
        localStorage.setItem("favorites", JSON.stringify([space_id]));
        this.toggleFav(space_id, 1);
      } else {
        if (fav_storage.indexOf(space_id) >= 0) {
          let index = fav_storage.indexOf(space_id);
          fav_storage.splice(index, 1);
          localStorage.setItem("favorites", JSON.stringify(fav_storage));

          this.toggleFav(space_id, 0);
        } else {
          fav_storage.push(space_id);
          localStorage.setItem("favorites", JSON.stringify(fav_storage));
          this.toggleFav(space_id, 1);
        }
      }
    } else {
      localStorage.setItem("favorites", JSON.stringify([space_id]));
      this.toggleFav(space_id, 1);
    }
    this.fav_upd_count();
  };

  updateFavCountHeader = () => {
    let favorites = this.state.favorite;
    ReactDOM.render(favorites, document.getElementById("fav_count"));
    document.getElementById("fav_heart").classList.add("animate");

    setTimeout(function() {
      document.getElementById("fav_heart").classList.remove("animate");
    }, 600);
  };

  render() {
    let favorites = JSON.parse(localStorage.getItem("favorites"));
    return (
      <i
        className={`fav_icon ${
          favorites && favorites.indexOf(this.props.space_id) >= 0
            ? "active"
            : ""
        }`}
        onClick={() => this.favorites(this.props.space_id)}
      />
    );
  }
}
